import { ApolloClient } from "@apollo/client";
import {
  ICreateRemittanceCreditMemoParams,
  ICreateRemittanceCreditMemoRepository,
  ICreateRemittanceCreditMemoRepositoryResponse,
} from "@/core/repositories/accounting";
import CREATE_REMITTANCE_CREDIT_MEMO from "@/core/graphql/accounting/createRemittanceCreditMemo";

export class RemittanceCreditMemoRepository implements ICreateRemittanceCreditMemoRepository {
  constructor(private readonly client: ApolloClient) {}

  public async createRemittanceCreditMemo(
    params: ICreateRemittanceCreditMemoParams
  ): Promise<ICreateRemittanceCreditMemoRepositoryResponse> {
    const { data } = await this.client.mutate({
      mutation: CREATE_REMITTANCE_CREDIT_MEMO,
      variables: {
        params,
      },
    });

    if (!data) {
      throw new Error("Failed to create remittance credit memo");
    }

    if (!data?.createRemittanceCreditMemo) {
      throw new Error("Failed to create journal entry");
    }

    return data;
  }
}
